// Module-level store for the current project id.
// Mirrors projectNameStore. Set when a project is loaded or freshly saved
// (since EditorTopBar uses history.replaceState to swap /editor/new/X for
// /editor/{id} without remounting, useParams() is stale until next nav).

import {useSyncExternalStore} from 'react'

let projectId: string | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

const notify = () => {
  listeners.forEach((l) => l())
}

export const setProjectId = (id: string) => {
  if (projectId === id) return
  projectId = id
  notify()
}

export const getProjectId = (): string | null => projectId

export const clearProjectId = () => {
  if (projectId === null) return
  projectId = null
  notify()
}

export const useProjectId = (): string | null => useSyncExternalStore(subscribe, getProjectId, getProjectId)
